<template>
	<div class="bg-white px-3" style="margin: -20px;margin-top: -1rem;margin-bottom: 0!important;">
		<div style="width: 100%;height: 20px;"></div>
		<el-button type="primary" icon="el-icon-search" size="mini">查询</el-button>
		<el-table class="mt-3" :data="tableData" style="width: 100%" @selection-change="handleSelectionChange" size="mini" key="table1">
			<el-table-column type="selection" width="45" align="center"></el-table-column>
			<el-table-column align="center" prop="id" width="50" label="编号" fixed="left"></el-table-column>
			<el-table-column type="expand" label="明细表" width="60">
				<template slot-scope="props">
					<el-form label-position="left" inline class="demo-table-expand">
						<el-table :data="tableDataa" style="width: 100%;margin-left: 95px;" key="table2" size="mini" :header-cell-style="{ background: '#f4faf4' }">
							<el-table-column prop="id" label="生产信息" width="80" align="center"></el-table-column>
							<el-table-column prop="name" label="成品名称" width="80"></el-table-column>
							<el-table-column prop="noid" label="成品编码" width="80" align="center"></el-table-column>
							<el-table-column prop="gemc" label="规格名称" width="80" align="center"></el-table-column>
							<el-table-column prop="gebm" label="规格编码" width="80" align="center"></el-table-column>
							<el-table-column prop="dw" label="单位" width="80" align="center"></el-table-column>
							<el-table-column prop="num" label="数量" width="80" align="center"></el-table-column>
						</el-table>
					</el-form>
				</template>
			</el-table-column>
			<el-table-column align="center" prop="id" width="100" label="报工编号"></el-table-column>
			<el-table-column align="center" prop="id" label="报工工序"></el-table-column>
			<el-table-column align="center" prop="id" label="工时数"></el-table-column>
			<el-table-column align="center" prop="id" label="报工数量"></el-table-column>
			<el-table-column align="center" prop="id" label="良品数"></el-table-column>
			<el-table-column align="center" prop="id" label="不良品数"></el-table-column>
			<el-table-column align="center" label="关联生产单">
				<template slot-scope="scope">
					<el-button type="success" size="mini" plain>MK132</el-button>
				</template>
			</el-table-column>
			<el-table-column align="center" label="报工人">
				<template slot-scope="scope">
					<el-button type="info" size="mini" plain>通用生产</el-button>
				</template>
			</el-table-column>
			<el-table-column align="center" prop="create_time" width="140" label="创建时间"></el-table-column>
			<!-- 操作 -->
			<el-table-column align="center" label="操作" fixed="right" width="180">
				<template slot-scope="scope">
					<div v-if="tab != 'delete'">
						<el-button type="primary" size="mini" @click="openModel(scope)">查看</el-button>
						<el-button type="warning" size="mini" @click="openModel(scope)">工序安排</el-button>
					</div>
					<div v-else>暂无操作</div>
				</template>
			</el-table-column>
		</el-table>
		<div style="height: 60px;"></div>
		<el-footer class="border-top d-flex align-items-center px-0 position-fixed bg-white" style="bottom: 0;left: 250px;right: 0;z-index: 100;">
			<div style="flex: 1;" class="px-2">
				<el-pagination
					:current-page="page.current"
					:page-sizes="page.sizes"
					:page-size="page.size"
					layout="total, sizes, prev, pager, next, jumper"
					:total="page.total"
					@size-change="handleSizeChange"
					@current-change="handleCurrentChange"
				></el-pagination>
			</div>
		</el-footer>
	</div>
</template>

<script>
import common from '@/common/mixins/common.js'; // 引入 全局共公样式
import { mapState } from 'vuex'; // 引入 全局 公共数据
export default {
	mixins: [common], // 引入mixins里的common.js
	inject: ['layout'], // 依赖注入

	data() {
		return {
			tableData: []
		};
	},
	// 生命周期监听页面
	methods: {}
};
</script>

<style></style>
